

<div class="page-layout simple fullwidth inner-scroll mat-white-bg" fusePerfectScrollbar>
  <div class="content">
    @if (isLoadingDone) {
      <div class="content-editor">
        <div class="gamecode-content">
          <iframe [src]="urlToGamecode" height="100%" width="100%"></iframe>
        </div>
      </div>
    } @else {
      <mat-spinner></mat-spinner>
    }
  </div>
</div>
